import { render, staticRenderFns } from "./NoteDocuments.vue?vue&type=template&id=4b71e30e&"
import script from "./NoteDocuments.vue?vue&type=script&lang=js&"
export * from "./NoteDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports